import Swal from 'sweetalert2';

export const showCustomAlert = (
  message = 'Are you sure?',
  icon: 'warning' | 'error' | 'success' | 'info' | 'question' = 'question',
) => {
  return Swal.fire({
    title: message,
    icon,
    background: 'var(--card)',
    color: 'var(--foreground)',
    confirmButtonText: 'Yes',
    cancelButtonText: 'No',
    showCancelButton: true,
    customClass: {
      popup: 'custom-swal-popup rounded-lg shadow-xl',
      confirmButton:
        'bg-therablue hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded transition-colors duration-200',
      cancelButton:
        'bg-dark ml-2 hover:bg-gray-300 text-white font-semibold py-2 px-4 rounded transition-colors duration-200',
      title: 'text-xl font-semibold text-gray-900',
      htmlContainer: 'text-gray-700 mt-2',
    },
    buttonsStyling: false,
    showClass: {
      popup: 'animate__animated animate__fadeInDown',
    },
    hideClass: {
      popup: 'animate__animated animate__fadeOutUp',
    },
  });
};
